<template>
  <b-modal
    id="copSmartpci"
    ref="copSmartModal"
    size="xl"
    :hide-footer="true"
    :no-close-on-esc="true"
    @hide="$emit('hide')"
  >
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.COP.Official}}
        </span>
        <button class="close" @click="$emit('hide')">x</button>
      </div>
    </template>
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      class="cop-smartpci-frame"
      title="COP"
    />
  </b-modal>
</template>

<script>
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import { actionTypes as AccountActions } from '@/store/module/account/actions'
import { actionTypes as CompanyActions } from '@/store/module/company/actions'

export default {
  name: 'CopSmartpci',
  mixins: [ AccountMixin, CompanyMixin ],
  data () {
    return {
      iframeUrl: null
    }
  },
  mounted () {
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
        if (!this.company) {
          this[CompanyActions.GET_COMPANY_BY_ID](response.empresaID)
        }
      })
  },
  methods: {
    show (pci) {
      const obraId = pci.obraId
      this.iframeUrl = `${process.env.SmartPciBaseURL}/#/embed/cop/${obraId}?empresaId=${this.company.id}`
      this.$refs.copSmartModal.show()
    }
  }
}
</script>

<style scoped>
  .cop-smartpci-frame {
    width: 100%;
    height: calc(100vh - 160px);
    border: 0;
    display: block;
  }

  * >>> .modal-header {
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
  }
  * >>> .modal-body {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    overflow: hidden;
    padding: 0;
  }
  * >>> .modal-content {
    border-radius: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/cop/cop-smartpci.vue